import { useEffect } from 'react';
import Lenis from 'lenis';
import { Toaster } from 'sonner';
import '@/App.css';

import Header from './components/Header';
import Hero from './components/Hero';
import MarqueeStrip from './components/MarqueeStrip';
import Manifesto from './components/Manifesto';
import Founder from './components/Founder';
import Products from './components/Products';
import Process from './components/Process';
import Quality from './components/Quality';
import ClientWall from './components/ClientWall';
import Contact from './components/Contact';
import FindUs from './components/FindUs';
import Footer from './components/Footer';
import Preloader from './components/Preloader';
import WhatsAppFab from './components/WhatsAppFab';

function App() {
    useEffect(() => {
        const lenis = new Lenis({
            duration: 1.2,
            easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
            smoothWheel: true,
            wheelMultiplier: 1,
            touchMultiplier: 1.5,
        });

        let rafId;
        const raf = (time) => {
            lenis.raf(time);
            rafId = requestAnimationFrame(raf);
        };
        rafId = requestAnimationFrame(raf);

        // Anchor link smooth-scroll integration
        const onAnchor = (e) => {
            const t = e.target.closest('a[href^="#"]');
            if (!t) return;
            const id = t.getAttribute('href');
            if (!id || id === '#') return;
            const el = document.querySelector(id);
            if (el) {
                e.preventDefault();
                lenis.scrollTo(el, { offset: -80 });
            }
        };
        document.addEventListener('click', onAnchor);

        return () => {
            cancelAnimationFrame(rafId);
            document.removeEventListener('click', onAnchor);
            lenis.destroy();
        };
    }, []);

    return (
        <div className="App">
            <Preloader />
            <Header />
            <main>
                <Hero />
                <MarqueeStrip />
                <Manifesto />
                <Founder />
                <Products />
                <Process />
                <Quality />
                <ClientWall />
                <Contact />
                <FindUs />
            </main>
            <Footer />
            <WhatsAppFab />
            <Toaster
                position="bottom-right"
                theme="dark"
                toastOptions={{
                    style: {
                        background: '#0A0A0B',
                        color: '#fff',
                        border: '1px solid rgba(255,255,255,0.15)',
                        borderRadius: 0,
                        fontFamily: 'JetBrains Mono, monospace',
                        fontSize: 12,
                        letterSpacing: '0.05em',
                    },
                }}
            />
        </div>
    );
}

export default App;
